<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ma1"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('storage_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('storage_add_button')"
          @click="funcAdd"
        >
          新增
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="客户名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <shipmentSelect
            ref="shipmentSelect"
            @setCustomerCode="selectCustomerCode"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="合同名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入合同名称"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="remarks"
          title="备注"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.remarks"
            placeholder="请输入备注"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        
        title="操作"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('storage_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDetail(scope.row.code)"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-toolti
            v-if="getLimit('storage_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcEdit(scope.row.code)"
            >
              <i class="el-icon-edit" />
            </vxe-button>
          </el-toolti>
          <el-tooltip
            v-if="getLimit('storage_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDelete(scope.row.code)"
            >
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="500"
      height="600"
      resize
    >
      <compAdd
        ref="addRef"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="500"
      height="600"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="500"
      height="600"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
  </div>
</template>
<script>
import compAdd from './components/contractAdd.vue'
import compEdit from './components/contractEdit.vue'
import compDetail from './components/contractDetail.vue'
import shipmentSelect from '@/views/components/shipmentSelect.vue'

import request from '@/utils/request'
export default {
  name: 'ContractList',
  components: {
    compAdd,
    compEdit,
    compDetail,
    shipmentSelect
  },
  data() {
    return {
      message: '',
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      copy: false,
      partys:[],
      listQuery: {
        code: '',
        groupCode: '',
        name: '',
        contractPath: '',
        shipmentCode:'',
        shipmentName:'',
        pageNum: 1,
        pageSize: 20,
        sortField: '',
        sortType: '',
        total: 0
      },
      Pagingconf: [],
    }
  },
  created() {
    this.findList()
    this.findShipmentPartys()
  },
  methods: {
    // 选择客户
    selectCustomerCode(value) {
      // this.listQuery.shipmentName = value.name
      this.listQuery.shipmentCode = value.code;
    },

    findShipmentPartys() {
      request({
        url: '/ntocc-basic-api/party/wmsShipment',
        method: 'get',
        params: { name: this.partyName }
      }).then(response => {
        this.partys = response.data
      })
    },
    findList() {
      this.loading = true
      request({
        url: '/ntocc-wms-api/contract',
        method: 'get',
        params: this.listQuery
      }).then(response => {
        this.tableData = response.data.records
        this.listQuery.total = response.data.total
          response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
        this.loading = false
      })
    },
    // 添加方法
    funcAdd() {
      this.modelAddFlag = true
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.getInfo(code)
      this.modelEditFlag = true
      this.$refs.editRef.partys = this.partys

    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code)
      this.modelDetailFlag = true
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm('确认删除吗？').then(_ => {
        request({ url: `/ntocc-wms-api/contract`, method: 'delete', params: { codes: row }}).then(response => {
          this.$message({ message: response.msg, type: 'success' })
          this.findList()
        })
      }).catch(_ => {})
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false
      this.findList()
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false
      this.findList()
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case 'add':
          this.modelAddFlag = false
          break
        case 'edit':
          this.modelEditFlag = false
          break
        case 'detail':
          this.modelDetailFlag = false
          break
        default:
      }
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return '合计'
          }
          if (['pageviews', 'forecast'].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property)
          }
          return null
        })
      ]
    }
  }
}
</script>

<style>
    
</style>
